module.exports = __webpack_public_path__ + "img/cafe-bou.9636d8d9.jpeg";